import React, { useMemo } from 'react';
import Icon from '../../../icons/Icon';
import LanguageUtil from '../../../util/LanguageUtil';
import SarValidationCategoryMapper from '../../../util/SarValidationCategoryMapper';
import { SarCategory, SarCategoryKey, SarValidationResult } from '../SarInterfaces';

const useSarCategories = (): SarCategory[] =>
  useMemo<SarCategory[]>(
    () => [
      { key: 'yukumlu', label: 'Yükümlü', icon: 'sar-icon' },
      { key: 'temelbilgiler', label: 'Temel Bilgiler', icon: 'sar-icon' },
      { key: 'gercekkisiler', label: 'Gerçek Kişiler', icon: 'sar-icon' },
      { key: 'digerkisiler', label: 'Diğer Kişiler', icon: 'sar-icon' },
      { key: 'supheliislemler', label: 'Şüpheli İşlemler', icon: 'sar-icon' },
      { key: 'hesaplar', label: 'Hesaplar', icon: 'sar-icon' },
      { key: 'suphekategorileri', label: 'Şüphe Kategorileri', icon: 'sar-icon' },
      { key: 'bildirimaciklama', label: 'Bildirim Açıklama', icon: 'sar-icon' },
    ],
    [],
  );

const SarCategoryList = ({ selectedCategory, onSelectCategory, validate }: Props) => {
  const categories = useSarCategories();
  const categoriesWithErrors = useMemo<Set<SarCategoryKey>>(() => {
    if (!validate || !validate.errors || validate.errors.length === 0) {
      return new Set<SarCategoryKey>();
    }
    return SarValidationCategoryMapper.getCategoriesWithErrors(validate.errors);
  }, [validate]);

  return (
    <aside className={'w-[320px]'}>
      <div className={'px-5 py-6 h-[calc(100%)] gap-y-3 flex flex-col'}>
        <div className={'text-md 2xl:text-lg font-semibold text-[#1D2939]'}>
          {LanguageUtil.get({
            id: `common.label.categories`,
            defaultMessage: 'Categories',
          })}
        </div>
        <div className={'flex flex-col gap-y-2 border p-3 rounded-[10px] h-full'}>
          {categories.map((category) => {
            const isSelected = category.key === selectedCategory;
            const hasError = categoriesWithErrors.has(category.key);
            return (
              <button
                key={category.key}
                type={'button'}
                className={`flex items-center w-full gap-x-3 rounded-lg px-4 h-[36px] text-sm font-medium text-[#1D2939] transition-colors relative ${
                  isSelected ? 'bg-main-gray' : 'bg-transparent hover:bg-main-gray'
                }`}
                onClick={() => onSelectCategory(category.key)}
              >
                <div className='w-[16px] h-[16px] 2xl:w-[18px] 2xl:h-[18px] flex items-center justify-center'>
                  <Icon icon={category.icon} className={'text-[#1D2939]'} />
                </div>
                <span className='flex-1 text-start'>{category.label}</span>
                {hasError && <div className='w-[8px] h-[8px] rounded-full bg-[#D92D20] flex-shrink-0' />}
              </button>
            );
          })}
        </div>
      </div>
    </aside>
  );
};

export interface Props {
  selectedCategory: SarCategoryKey;
  onSelectCategory: (category: SarCategoryKey) => void;
  validate?: SarValidationResult;
}

export default SarCategoryList;
